 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		12: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "sports2-static/chunk." + ({"0":"source~/esports-betting-rules-TR~bet-builder-rules-AZ~bet-builder-rules-DE~bet-builder-rules-EN~bet-~9a7cfb37","1":"source~/esports-betting-rules-TR~bet-builder-rules-AZ~bet-builder-rules-DE~bet-builder-rules-EN~bet-~f1a6f51d","2":"source~/esports-betting-rules-TR~esports-betting-rules-AZ~esports-betting-rules-DA~esports-betting-r~c810e73c","4":"source~virtual-esports-betting-rules-AZ~virtual-esports-betting-rules-EN~virtual-esports-betting-rul~8df6e383","7":"source~bet-details-page~betting-history-page","8":"source~i18n-widgets-en-json","9":"source~i18n-widgets-es-json","10":"source~i18n-widgets-pt-json","13":"source~/esports-betting-rules-TR","14":"source~bet-builder-rules-AZ","15":"source~bet-builder-rules-DE","16":"source~bet-builder-rules-EN","17":"source~bet-builder-rules-ES","18":"source~bet-builder-rules-ES-MX","19":"source~bet-builder-rules-ET","20":"source~bet-builder-rules-FI","21":"source~bet-builder-rules-FR","22":"source~bet-builder-rules-IT","23":"source~bet-builder-rules-JA","24":"source~bet-builder-rules-KA","25":"source~bet-builder-rules-LT","26":"source~bet-builder-rules-LV","27":"source~bet-builder-rules-PL","28":"source~bet-builder-rules-PT-BR","29":"source~bet-builder-rules-RO","30":"source~bet-builder-rules-RU","31":"source~bet-builder-rules-SQ","32":"source~bet-builder-rules-SV","33":"source~bet-builder-rules-TR","34":"source~bet-details-page","35":"source~betting-history-container","36":"source~betting-history-page","37":"source~betting-rules-AZ","38":"source~betting-rules-DA","39":"source~betting-rules-DE","40":"source~betting-rules-EN","41":"source~betting-rules-ES","42":"source~betting-rules-ES-MX","43":"source~betting-rules-FR","44":"source~betting-rules-IT","45":"source~betting-rules-JA","46":"source~betting-rules-PL","47":"source~betting-rules-PT","48":"source~betting-rules-PT-BR","49":"source~betting-rules-RO","50":"source~betting-rules-RU","51":"source~betting-rules-SQ","52":"source~betting-rules-SV","53":"source~betting-rules-TR","54":"source~bonus-info","55":"source~cashout-terms-AR","56":"source~cashout-terms-AZ","57":"source~cashout-terms-DA","58":"source~cashout-terms-DE","59":"source~cashout-terms-EN","60":"source~cashout-terms-ES","61":"source~cashout-terms-ES-MX","62":"source~cashout-terms-ET","63":"source~cashout-terms-FI","64":"source~cashout-terms-FR","65":"source~cashout-terms-IT","66":"source~cashout-terms-JA","67":"source~cashout-terms-KA","68":"source~cashout-terms-KU","69":"source~cashout-terms-LT","70":"source~cashout-terms-LV","71":"source~cashout-terms-PL","72":"source~cashout-terms-PT","73":"source~cashout-terms-PT-BR","74":"source~cashout-terms-RO","75":"source~cashout-terms-RU","76":"source~cashout-terms-SQ","77":"source~cashout-terms-SR","78":"source~cashout-terms-SV","79":"source~cashout-terms-TR","80":"source~esports-betting-rules-AZ","81":"source~esports-betting-rules-DA","82":"source~esports-betting-rules-DE","83":"source~esports-betting-rules-EN","84":"source~esports-betting-rules-ES","85":"source~esports-betting-rules-ES-MX","86":"source~esports-betting-rules-ET","87":"source~esports-betting-rules-FI","88":"source~esports-betting-rules-FR","89":"source~esports-betting-rules-IT","90":"source~esports-betting-rules-JA","91":"source~esports-betting-rules-KA","92":"source~esports-betting-rules-LT","93":"source~esports-betting-rules-LV","94":"source~esports-betting-rules-PL","95":"source~esports-betting-rules-PT","96":"source~esports-betting-rules-PT-BR","97":"source~esports-betting-rules-RO","98":"source~esports-betting-rules-RU","99":"source~esports-betting-rules-SQ","100":"source~esports-betting-rules-SR","101":"source~esports-betting-rules-SV","102":"source~generated-mappings","103":"source~i18n-en-json","104":"source~i18n-es-json","105":"source~i18n-pt-json","107":"source~settings-page","108":"source~streaming-carousel","109":"source~virtual-esports-betting-rules-AZ","110":"source~virtual-esports-betting-rules-EN","111":"source~virtual-esports-betting-rules-IT","112":"source~virtual-esports-betting-rules-JA","113":"source~virtual-esports-betting-rules-PL","114":"source~virtual-esports-betting-rules-RU","116":"vendors~rc-slider","117":"vendors~react-google-recaptcha","118":"vendors~streaming-carousel"}[chunkId]||chunkId) + "." + {"0":"b6455347a17c82fb8bba","1":"70763af78158541aa37d","2":"2bcc455438d1497f35d3","3":"52eb989790f4ab49c428","4":"9fb83ec693521bcf0e0c","5":"27ba64988b259c850667","6":"94a9b7873ed7eb13d760","7":"38153118c1081b089eae","8":"7b0832ee58fdbc2f809a","9":"7234d031af2da07bde22","10":"a2b921af5fe78cafa44d","13":"1cf73940e592b68a4b62","14":"7da7ec8966dd4e62edf0","15":"f8cec3ae19f31bdfa844","16":"0d426b10b14d96cf0c46","17":"8d3d12486fcef047be08","18":"e680cf44a07cb4fce667","19":"c23054412b8cd080ce3f","20":"b6b62cee5637202c98bb","21":"5daaa3e759c0f33d9db5","22":"b32076a5214a529bc5e1","23":"42c740c1119c6f5a1167","24":"d652b07709ccef3c992c","25":"ecba504638fa9959b46a","26":"359d46e8370179eba3cd","27":"6347c7c7890431c6f93e","28":"f4729a0a0571edfe2ffc","29":"1a0a4b2c82d7aad69be3","30":"ddfc7f191ab727c47890","31":"cebd070e0432704b98c4","32":"81b8bc039b2056caa6d4","33":"4db00052f76100da619f","34":"142d7af38371ea00976c","35":"e4614adad8d36747e609","36":"20fde2dd7836ee4f437d","37":"24e078c49114539cf88c","38":"5ed3cacfea97a000d43a","39":"b1cb8248a50948b37ac7","40":"e72a47e157bf2de5cd77","41":"355bb491fa5b0646372a","42":"14adbbdc59aa73ee103f","43":"502d806e1d25bd49aeae","44":"0407832f3ba342b0bb68","45":"f1f565df011c3982c4d4","46":"8b82ed21ddb2b665a76a","47":"249d132d08446144ad70","48":"d7c733c1a6e21508daf2","49":"2ae2648e7b2de3070928","50":"18c6b73cb2d582a4c258","51":"7bbd4dc88171321fc12b","52":"dafca2e7141f83f9315c","53":"07ce2884a7a0c1db66f9","54":"40e55825296acc8a8c03","55":"73b3888ea26fc3eaf0cb","56":"f1d95f5532b8fcfe43bf","57":"66cb36400765efd02352","58":"a1c5200c40fd097410ab","59":"059104a5e9504d993a5b","60":"c573f1af93d4020728cb","61":"f961895080dfaea18600","62":"e0063bf4bbeccf29e9da","63":"367da6e646ea7ad2b61c","64":"eedd45c01f8c9dbd1962","65":"5de7b449ed9a07e4015a","66":"790c81f014185bdf278f","67":"1f63cc95d7bfa3a438cb","68":"773b74c3fa34b1966574","69":"a56f49106d4cd36b8b4e","70":"43317e5fb878ad66daab","71":"c65554f82703f3719d15","72":"7b5201822278cc7a10a6","73":"889a0ca0f85c3e06b6b8","74":"ffa22e66f87f359cee43","75":"ec3419025c89f9e3bc56","76":"a8621730f35ff4a1bd36","77":"60983e89c40f686a92be","78":"10c603440be6037791f8","79":"8897d9b29b1f56334264","80":"f45d41a710401de41804","81":"a48ede14f49f1c4570ab","82":"e356ff38b50bb371db38","83":"87beb0df35cb406c6012","84":"646c007a8183ed47a9e7","85":"271a3dcfa614d7da438b","86":"adbbcdc10333d8cc9e40","87":"683f586418a99d76b446","88":"637bf7b8188b62db7fb5","89":"cff2e68eb2d5fedfcaab","90":"08357cb305ce9559c58b","91":"b923479e18b4b2dd7c91","92":"9e89130a74af54981bda","93":"0327718be5b2e1e70fe0","94":"7c81f4d03588d86b64ca","95":"de9de8b94560bfba8e53","96":"1fafc35bf09b5db3da9b","97":"8ddf84c8b10ad87effa9","98":"dad4b1e9ff6a68c5813d","99":"d6b54f2aefce9abd1348","100":"8fdf8f5165efcd5f1610","101":"78e9bbe27eb30d7fe406","102":"1f3c7a46ffa001b4638d","103":"f4fd576b6ec28d47fa3a","104":"9344cf8412b497701949","105":"faff0eba5f5946a9da0a","107":"0d6bc9ee65df2967eddb","108":"56ae9512e281d36f1773","109":"726479356dc197b839e6","110":"a79ddd8205743e892606","111":"c3f852bd3dc0936ce09e","112":"678b6788a8afd66de688","113":"c25264d604664962337d","114":"57a138d5de376c830458","116":"c6ea56889cd8c19b92d9","117":"8a236dc4b885690d5613","118":"f0bde3c40384d8ea345f","119":"92f71246865a5444a7e6","120":"28f8a271ab20c4112112","121":"3427d1b98d730c52f79d","122":"ada6b982ce2a6af324a6","123":"aeb9142bb32343dca6b0","124":"f158bf45003b1333d519","125":"05b13b13d3aba351694a","126":"f3b6ec62eb0232796e54","127":"5e9ac03ff9c7195e29c2","128":"35b3d79afa8fd472d2bf","129":"cafb7c798e2139e883a5","130":"0d76dad1990500f5dd84","131":"84b21c5991d46e318600","132":"ed350bb73383d945cb71","133":"91fe90a9597c05d2e39d","134":"5645b103549118b9f707","135":"a361a88f279bda9186be","136":"5bdae7ae3987bdc831ab","137":"969583d00fbd75e4a495","138":"71bb0d42d83bb08c325d","139":"f62e8c3c8db558ad0666","140":"cecb34705b8289e134e1"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonpOMFE2_App"] = window["webpackJsonpOMFE2_App"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
